/***
 * @file: 
 * @author: xiaoyu.chen
 * @Date: 2025-08-13 15:56:56
 */
export default defineNuxtRouteMiddleware((to, from) => {
  if (to?.meta?.title) {
    useHead({
      title: to.meta.title || "测试"
    })
  }
})